import { Button, EpicIcons } from "@constellation-academy/epic-ui";
import { graphql, useMutation } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { type CreateMultipleChoiceElementButton_CreateMultipleChoiceElementV2Mutation } from "../../../__generated__/CreateMultipleChoiceElementButton_CreateMultipleChoiceElementV2Mutation.graphql";
import { E_LEARNING_I18N_KEY, E_LEARNING_I18N_MAP } from "../../../translations/tree";
import { useDraftStatusUpdater } from "./use-draft-status-updater";

const CREATE_MULTIPLE_CHOICE_ELEMENT_MUTATION = graphql`
	mutation CreateMultipleChoiceElementButton_CreateMultipleChoiceElementV2Mutation(
		$input: CreateMultipleChoiceElementV2Input!
	) {
		Admin {
			ElearningV2 {
				createMultipleChoiceElement(input: $input) {
					eLearningContentNode {
						...contentCard_TreeNodeFragment
					}
				}
			}
		}
	}
`;

type OwnProps = {
	eLearningContentNodeId: string;
};

export const CreateMultipleChoiceElementButton = ({ eLearningContentNodeId }: OwnProps) => {
	const { t } = useTranslation("common");
	const setDraft = useDraftStatusUpdater();
	const [createMultipleChoiceElement, isCreatingMultipleChoiceElement] =
		useMutation<CreateMultipleChoiceElementButton_CreateMultipleChoiceElementV2Mutation>(
			CREATE_MULTIPLE_CHOICE_ELEMENT_MUTATION,
		);

	return (
		<Button
			disabled={isCreatingMultipleChoiceElement}
			tooltip={t("educationalOffer.eLearning.createElement", {
				element: E_LEARNING_I18N_MAP(E_LEARNING_I18N_KEY.multipleChoiceElement),
			})}
			icon={EpicIcons.QUESTION}
			onClick={() => {
				createMultipleChoiceElement({
					variables: {
						input: {
							title: t("educationalOffer.newElement"),
							question: "",
							answeringType: "allowOnlyOneAnswer",
							answerOptions: [],
							eLearningContentNodeId,
						},
					},
					updater: setDraft,
				});
			}}
		/>
	);
};
